import { TABLE_THEME } from '@/components/custom/erp/table-theme';

export const inputTableClassName = [
  'border-0',
  '[&_table]:text-[12.5px]',
  TABLE_THEME.inputHeaderCell,
  '[&_thead_th]:text-[12.5px]',
  '[&_thead_th_span]:px-0 [&_thead_th_span]:font-medium',
  TABLE_THEME.inputBodyCell,
  '[&_tbody_td]:px-[10px] [&_tbody_td]:py-0 [&_tbody_td]:text-[12.5px]',
  '[&_tbody_td>div]:py-0',
  '[&_tbody_td:first-child]:pr-0 [&_tbody_td:first-child]:text-right [&_tbody_td:first-child>div]:justify-end',
  '[&_td.selected-cell]:!border-2',
  TABLE_THEME.inputSelectedCell
].join(' ');
